exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss"), "");
// Module
exports.push([module.id, ".stage-area-stage-area-55iOzck4mwr{position:relative;background-color:var(--top-bar);flex-shrink:0;padding:32px}.stage-area-stage-area-55iOzck4mwr.stage-area-inModal-78TH885Gmwr{padding:20px}@media (min-width: 1300px){.stage-area-stage-area-55iOzck4mwr{padding:32px}.stage-area-stage-area-55iOzck4mwr.stage-area-inModal-78TH885Gmwr{padding:32px}}@media (min-width: 1500px){.stage-area-stage-area-55iOzck4mwr{padding:32px}.stage-area-stage-area-55iOzck4mwr.stage-area-inModal-78TH885Gmwr{padding:32px}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"stage-area": "stage-area-stage-area-55iOzck4mwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["bottom-divider"] + "",
	"stageArea": "stage-area-stage-area-55iOzck4mwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["bottom-divider"] + "",
	"inModal": "stage-area-inModal-78TH885Gmwr"
};